/**
 * <AttendanceTable 
 *		// please describe props here
 *	/>
 *
 * - When there is a nesting tr, we use tbody as a row.
 *
 * @parent anybody
 * @children 
 * @stateful
 * @stateless
 */
import React, { PropTypes } from 'react';
import ReactHTMLTableToExcel from 'vendor/react-html-table-to-excel';
import moment from 'moment'
import { Line } from 'rc-progress';
import classnames from 'classnames'
import getTradeRecord from 'controllers/school/getTradeRecord'
import Loading from 'components/UI/Loading';
import {CSVLink} from 'react-csv';
import {
  Table,
} from 'components/UI'
import { PAYMENT_METHOD } from 'data/constants'
import locale from '../locale.js';

class FinanceTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      recordList: [],
      recordDetail: {},
      doneFetching: false,
      downloaded: false            
    };
    this.currentPage = 1;
    this.csvRecordList = [];
    this.fetchTradeRecord = this.fetchTradeRecord.bind(this);
  }

  componentWillMount() {
    this.fetchTradeRecord(()=>{
      this.setState({doneFetching: true})
    });
  }

  fetchTradeRecord(done) {
    const schoolId = localStorage.getItem('schoolId');
    const { params } = this.props;
    getTradeRecord(schoolId, {
      student_id_list: params.student_id_list? params.student_id_list: null,
      class_id_list: params.class_id_list? params.class_id_list: null,
      start_date: params.start_date? params.start_date : null,
      end_date: params.end_date? params.end_date: null,
      transaction_number: params.transaction_number? params.transaction_number: null,
      paging_or_not: 1,
      amount_per_page: 50,
      page_number: this.currentPage
    }).then((result)=>{
      this.setState({recordList: this.state.recordList.concat(result.result_list), recordDetail: result},()=>{
        this.csvRecordList = this.state.recordList.map((record)=>{
          let recordList = {};
          
          recordList[__('Date', 'class')] = record.transaction_date;
          recordList[__('E-Receipt No.', 'finance')] = record.transaction_number;
          recordList[__('Student', 'finance')] = record.student_name;
          recordList[__('Class', 'student')] = record.class_name ? record.class_name : __('School Credit', 'PaymentModal');
          recordList[__('Charge/Refund', 'finance')] = record.trType == 1 ? __('Charge', 'finance') : __('Refund', 'finance');
          recordList[__('Amount', 'finance')] = record.trTransactionAmount;
          recordList[__('Payment Methods', 'finance')] = PAYMENT_METHOD[record.source_or_direction];
          recordList[__('Purchased Lessons', 'finance')] = this.renderPurchasedLesson(record);
          recordList[__('Operator', 'finance')] = record.operator_name;
          return recordList;
        })
      })          
      if(this.currentPage>=result.page_amount) {
        done();
        return;
      }
      this.currentPage++;          
      this.fetchTradeRecord(done);
    })
  }
  renderPurchasedLesson(record) {
    if(record.class_name.length == 0){
      return 'N/A';
    }
    else if(record.trEndDate){
      return __('To', 'finance') + ' ' + record.trEndDate;
    }else {
      return Math.round(record.trQuantity) + __('', 'classdetail')
    }
  }
  renderTransactionRecords() {
    let recordList = [];
    if(this.state.recordList.length> 0){
      this.state.recordList.forEach((record)=>{
        recordList.push(
            <tr style={{textAlign:'center'}} key={record.id}>
              <td>{record.transaction_date}</td>
              <td>{record.transaction_number}</td>
              <td>{record.student_name}</td>
              <td>{record.class_name ? record.class_name : __('School Credit', 'PaymentModal')}</td>
              <td>{record.trType == 1 ? __('Charge', 'finance') : __('Refund', 'finance')}</td>
              <td>{record.trTransactionAmount}</td>
              <td>{PAYMENT_METHOD[record.source_or_direction]}</td>
              <td>{this.renderPurchasedLesson(record)}</td>
              <td>{record.operator_name}</td>
            </tr>
        )
      })
    }
    return recordList
  }
  renderDownloadBtn() {
    const {format} = this.props;    
    if(!this.state.doneFetching && this.state.recordDetail.page_amount) {
      return (
        <div style={{height:40, textAlign: 'center'}}>
          <Line percent={(this.currentPage/this.state.recordDetail.page_amount)*100} strokeWidth="4" strokeColor="#346aff" />
          <p>{__('Loading...', locale) + ' ' + Math.round((this.currentPage/this.state.recordDetail.page_amount)*100) }%</p>
        </div>
      );
    } else if(this.state.doneFetching && !this.state.downloaded) {
      return(
        <span className="downloadBtnWrapper" onClick={()=>{this.setState({downloaded: true})}}>
          {
            format==='excel' &&
            <ReactHTMLTableToExcel
              className={'btn btn-primary download-btn'}
              table='finance-table'
              filename={'School Transaction Records'}
              sheet='finance-table'
              buttonText={__('Download', locale)}
            />
          }
          {
            format==='csv' && 
            <CSVLink 
              data={this.csvRecordList} 
              filename="School Transaction Records.csv" 
              className="btn btn-primary download-btn"
              target='_self'>
              {__('Download', locale)}
            </CSVLink>            
          }

        </span>
      )
    } else if(this.state.doneFetching && this.state.downloaded){
      return(
        <div>
          <h3 className='download-success-text'>{__('Download Successfully!', locale)}</h3>
          {
            format === 'excel' &&
            <ReactHTMLTableToExcel
              className={'btn-link redownload-btn'}
              table='finance-table'
              filename={'School Transaction Records'}
              sheet='finance-table'
              buttonText={__('Redownload', locale)}
            />
          }
          {
            format === 'csv' && 
            <CSVLink 
              data={this.csvRecordList} 
              filename="School Transaction Records.csv" 
              className="btn-link redownload-btn"
              target='_self'>
              {__('Redownload', locale)}
            </CSVLink>            
          }
        </div>
      )
    } else {
      return null;
    }
  }
  render() {
    return (
      <div className='FinanceTable'>
        {this.renderDownloadBtn()}
        <table id='finance-table' style={{width:'100%', display: 'none'}}>
            <tr style={{fontSize: 15, color:'#fff', backgroundColor:'#3b67bc' }}>
                <th>{__('Date', 'class')}</th>
                <th>{__('E-Receipt No.', 'finance')}</th>
                <th>{__('Student', 'finance')}</th>
                <th>{__('Class', 'student')}</th>
                <th>{__('Charge/Refund', 'finance')}</th>
                <th>{__('Amount', 'finance')}</th>
                <th>{__('Payment Methods', 'finance')}</th>
                <th>{__('Purchased Lessons', 'finance')}</th>
                <th>{__('Operator', 'finance')}</th>
            </tr>
            {this.renderTransactionRecords()}
        </table>
      </div>
    )
  }
}

export default FinanceTable;



// WEBPACK FOOTER //
// ./src/template/Modals/Export/table/Finance.js